import React, { useState } from "react";
import "./styles.scss";
// import "./mobile.scss";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { MenuButton } from "../../../components";

const Index = (props) => {
  const [menuName, setMenuName] = useState("");
  const { location } = props;

  return (
    <>
      <div className="hne_left_menu_wrapper">
        <div style={{ marginTop: "20px" }}>
          <MenuButton
            content={"Dashbaord"}
            type={menuName === "dashboard"}
            onClick={() => {
              setMenuName("Dashboard");
            }}
          />

          <MenuButton
            content={"Category"}
            isActive={location.pathname === "/admin/category"}
            onClick={() => {
              setMenuName("Category");
              props.history.push("/admin/category");
            }}
          />

          <MenuButton
            content={"Menu"}
            // type={menuName === "menu" ? "active" : ""}
            isActive={location.pathname === "/admin/menus"}
            onClick={() => {
              setMenuName("Menu");
              props.history.push("/admin/menus");
            }}
          />

          <MenuButton
            content={"News"}
            // type={menuName === "news" ? "active" : ""}
            isActive={location.pathname === "/admin/news"}
            onClick={() => {
              setMenuName("News");
              props.history.push("/admin/news");
            }}
          />

          <MenuButton
            content={"Advertisement"}
            // type={menuName === "news" ? "active" : ""}
            isActive={location.pathname === "/admin/advertisement"}
            onClick={() => {
              setMenuName("Advertisement");
              props.history.push("/admin/advertisement");
            }}
          />
          <MenuButton
            content={"Adv Category"}
            // type={menuName === "news" ? "active" : ""}
            isActive={location.pathname === "/admin/adv-category"}
            onClick={() => {
              setMenuName("Adv Category");
              props.history.push("/admin/adv-category");
            }}
          />
          <MenuButton
            content={"Jobs"}
            // type={menuName === "news" ? "active" : ""}
            isActive={location.pathname === "/admin/jobs"}
            onClick={() => {
              setMenuName("Jobs");
              props.history.push("/admin/jobs");
            }}
          />
          <MenuButton
            content={"Jobs Category"}
            // type={menuName === "news" ? "active" : ""}
            isActive={location.pathname === "/admin/jobs-category"}
            onClick={() => {
              setMenuName("Jobs Category");
              props.history.push("/admin/jobs-category");
            }}
          />
          <MenuButton
            content={"Tags"}
            // type={menuName === "news" ? "active" : ""}
            isActive={location.pathname === "/admin/tags"}
            onClick={() => {
              setMenuName("Tags");
              props.history.push("/admin/tags");
            }}
          />
          <MenuButton
            content={"Widgets"}
            // type={menuName === "news" ? "active" : ""}
            isActive={location.pathname === "/admin/widgets"}
            onClick={() => {
              setMenuName("Widgets");
              props.history.push("/admin/widgets");
            }}
          />

          <MenuButton
            content={"Site-map"}
            // type={menuName === "news" ? "active" : ""}
            isActive={location.pathname === "/admin/site-map"}
            onClick={() => {
              setMenuName("site-map");
              props.history.push("/admin/site-map");
            }}
          />

          <MenuButton
            content={"Live Feed"}
            // type={menuName === "news" ? "active" : ""}
            isActive={location.pathname === "/admin/live-feed"}
            onClick={() => {
              setMenuName("live-feed");
              props.history.push("/admin/live-feed");
            }}
          />
          <MenuButton
            content={"Comments"}
            // type={menuName === "news" ? "active" : ""}
            isActive={location.pathname === "/admin/comments"}
            onClick={() => {
              setMenuName("comment");
              props.history.push("/admin/comments");
            }}
          />

          <MenuButton
            content={"Data Warehouse"}
            // type={menuName === "news" ? "active" : ""}
            isActive={location.pathname === "/admin/warehouse"}
            onClick={() => {
              setMenuName("warehouse");
              props.history.push("/admin/warehouse");
            }}
          />
          <MenuButton
            content={"Government Gazette"}
            // type={menuName === "news" ? "active" : ""}
            isActive={location.pathname === "/admin/gazette"}
            onClick={() => {
              setMenuName("gazette");
              props.history.push("/admin/gazette");
            }}
          />
          {/* <MenuButton
            content={"Procurement Notice"}
            // type={menuName === "news" ? "active" : ""}
            isActive={location.pathname === "/admin/procurement"}
            onClick={() => {
              setMenuName("procurement");
              props.history.push("/admin/procurement");
            }}
          /> */}
        </div>
      </div>
    </>
  );
};

export default withRouter(Index);
